type PolaroidInfo = {
  pic: string;
};

const polaroids: PolaroidInfo[] = [
  {
    pic: "/images/snailmail/eboard_bday.jpg",
  },
  {
    pic: "/images/snailmail/eboard_bday_1.jpg",
  },
  {
    pic: "/images/snailmail/michelle_cake.jpg",
  },
  {
    pic: "/images/snailmail/avi_julie_2.png",
  },
  {
    pic: "/images/snailmail/emily_julie.jpeg",
  },
  {
    pic: "/images/snailmail/polaroid_1.jpeg",
  },
  {
    pic: "/images/snailmail/tina_kendra.jpg",
  },
  {
    pic: "/images/snailmail/toast.jpg",
  },
  {
    pic: "/images/snailmail/eboard_wellness.jpg",
  },
  {
    pic: "/images/snailmail/polaroid_2.jpeg",
  },
  {
    pic: "/images/snailmail/polaroid_3.jpeg",
  },
  {
    pic: "/images/snailmail/emily_julie_2.png",
  },
  {
    pic: "/images/snailmail/four_1.jpg",
  },
  {
    pic: "/images/snailmail/eboard_vday.jpg",
  },
  {
    pic: "/images/snailmail/four_2.jpg",
  },
  {
    pic: "/images/snailmail/kaiti_1.jpg",
  },
  {
    pic: "/images/snailmail/kaiti_2.jpg",
  },
  {
    pic: "/images/snailmail/kaiti_3.jpg",
  },
  {
    pic: "/images/snailmail/tuyet_havi.jpg",
  },
  {
    pic: "/images/snailmail/trio_1.jpg",
  },
  {
    pic: "/images/snailmail/kiara_emily_michelle.jpg",
  },
  {
    pic: "/images/snailmail/duo_3.jpg",
  },
  {
    pic: "/images/snailmail/duo_1.jpg",
  },
  {
    pic: "/images/snailmail/duo_2.jpg",
  },
  {
    pic: "/images/snailmail/four_3.jpg",
  },
  {
    pic: "/images/snailmail/alicia_shristi_michelle.jpg",
  },
  {
    pic: "/images/snailmail/four_4.jpg",
  },
  {
    pic: "/images/snailmail/new_eb.jpg",
  },
  {
    pic: "/images/snailmail/eb_2026.jpg",
  },
  {
    pic: "/images/snailmail/tina_moms.jpg",
  },
  {
    pic: "/images/snailmail/og_babysnails.jpg",
  },
  {
    pic: "/images/snailmail/eb_2025.jpg",
  },
  {
    pic: "/images/snailmail/anna_tuyet.jpg",
  },
];

export { polaroids };
